module.exports = __webpack_public_path__ + "028a6e35935c6db46187a623b7ad25e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gorgutz-main-1024.jpg
// module id = 354
// module chunks = 0